export default "__VITE_ASSET__C5CmVj7P__"